<template>
  <div class="ad-tab-wrapper">
    <div class="ad-tab-nav">
      <ul uk-switcher="connect: #notification-tab-content; animation: uk-animation-slide-right-medium, uk-animation-slide-left-medium">
        <li>
          <a href="javascript:void(0)">
            <i class="uil-bell"></i>
            <span>{{ $t('general.notifications_announcements') }}</span>
          </a>
        </li>
        <li>
          <a href="javascript:void(0)">
            <i class="uil-circle-layer"></i>
            <span>{{ $t('general.my_pending_actions') }}</span>
          </a>
        </li>
      </ul>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "NotificationTabs",
};
</script>

<style scoped>
.ad-tab-wrapper {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow: visible;
}

.ad-tab-nav {
  padding: 16px 24px 0;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
}

.ad-tab-nav ul {
  display: flex;
  gap: 6px;
  list-style: none;
  margin: 0;
  padding: 0;
}

.ad-tab-nav li a {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 500;
  color: #64748b;
  text-decoration: none;
  border-radius: 10px 10px 0 0;
  transition: all 0.25s ease;
  position: relative;
  background: transparent;
  border: 1px solid transparent;
  border-bottom: none;
  margin-bottom: -1px;
}

.ad-tab-nav li a i {
  font-size: 17px;
}

.ad-tab-nav li a:hover {
  color: #334155;
  background: #f1f5f9;
}

.ad-tab-nav li.uk-active a {
  color: #1e293b;
  font-weight: 600;
  background: #fff;
  border-color: #e2e8f0;
  box-shadow: 0 -2px 6px rgba(0, 0, 0, 0.03);
  z-index: 1;
}

.ad-tab-nav li.uk-active a::before,
.ad-tab-nav li.uk-active a::after {
  content: "";
  position: absolute;
  bottom: 0;
  width: 10px;
  height: 10px;
  background: transparent;
}

.ad-tab-nav li.uk-active a::before {
  left: -10px;
  border-bottom-right-radius: 10px;
  box-shadow: 4px 0 0 0 #fff;
  border-right: 1px solid #e2e8f0;
  border-bottom: 1px solid #e2e8f0;
}

.ad-tab-nav li.uk-active a::after {
  right: -10px;
  border-bottom-left-radius: 10px;
  box-shadow: -4px 0 0 0 #fff;
  border-left: 1px solid #e2e8f0;
  border-bottom: 1px solid #e2e8f0;
}

@media (max-width: 960px) {
  .ad-tab-nav li a {
    padding: 9px 16px;
    font-size: 13px;
  }

  .ad-tab-nav li.uk-active a::before,
  .ad-tab-nav li.uk-active a::after {
    width: 8px;
    height: 8px;
  }

  .ad-tab-nav li.uk-active a::before {
    left: -8px;
    border-bottom-right-radius: 8px;
  }

  .ad-tab-nav li.uk-active a::after {
    right: -8px;
    border-bottom-left-radius: 8px;
  }
}

@media (max-width: 768px) {
  .ad-tab-wrapper {
    border-radius: 10px;
  }

  .ad-tab-nav {
    padding: 10px 14px 0;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
  }

  .ad-tab-nav::-webkit-scrollbar {
    display: none;
  }

  .ad-tab-nav ul {
    gap: 4px;
    width: max-content;
    min-width: max-content;
    flex-wrap: nowrap;
  }

  .ad-tab-nav ul li {
    flex: 0 0 auto;
  }

  .ad-tab-nav li a {
    padding: 8px 14px;
    font-size: 13px;
    gap: 6px;
    white-space: nowrap;
    border-radius: 8px 8px 0 0;
    width: auto;
    justify-content: flex-start;
  }

  .ad-tab-nav li a i {
    font-size: 16px;
  }

  .ad-tab-nav li.uk-active a::before,
  .ad-tab-nav li.uk-active a::after {
    width: 7px;
    height: 7px;
  }

  .ad-tab-nav li.uk-active a::before {
    left: -7px;
    border-bottom-right-radius: 7px;
  }

  .ad-tab-nav li.uk-active a::after {
    right: -7px;
    border-bottom-left-radius: 7px;
  }
}

@media (max-width: 480px) {
  .ad-tab-nav {
    padding: 8px 10px 0;
  }

  .ad-tab-nav ul {
    gap: 4px;
  }

  .ad-tab-nav li a {
    min-height: 48px;
    box-sizing: border-box;
    padding: 10px 12px;
    font-size: 14px;
    gap: 6px;
  }

  .ad-tab-nav li a span {
    display: inline !important;
    visibility: visible !important;
    font-size: 14px;
  }

  .ad-tab-nav li a i {
    font-size: 18px;
  }

  .ad-tab-nav li.uk-active a::before,
  .ad-tab-nav li.uk-active a::after {
    display: none;
  }
}
</style>
